const generateSequenceName = (prefix: string, existingCount: number): string => {
    let index = existingCount;
    let name = "";

    do {
        name = String.fromCharCode(65 + (index % 26)) + name;
        index = Math.floor(index / 26) - 1;
    } while (index >= 0);

    return `${prefix} ${name}`;
}

export default generateSequenceName;